@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.support

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.support.ExtendedSupportItemDto


object GetSupportListEndpoint : EndPoint<GetSupportListEndpoint.Request, GetSupportListEndpoint.Response>() {
    class Request(
        val isActive: Boolean?,
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String?,
    )

    class Response(
        val list: Array<ExtendedSupportItemDto>,
        val total: Int
    )
}